// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1DLIN","headerContent":"styles_headerContent__1BKSe","column":"styles_column__3HlgM","children":"styles_children__3aA9R","active":"styles_active__2SigZ"};